import { ButtonContainer } from "../../generic-sprites/Buttons"

export enum MakeVideoSpriteTypes {
    INTRO_TATE,
    INTRO_BAND,
    CHEERING_CROWD,
    THOUGHT_BUBBLE,
    TITLE_SPRITE,
    MUSIC_BUTTONS,
    CLIP_PREVIEW,
    VIDEO_TIMELINE,
    TITLE_SELECTION,
    BACKGROUND_SELECTION,
    VIDEO_PLAYER
}

export enum MakeVideoMusicButtonType {
    HIP_HOP = "Hip Hop",
    COUNTRY = "Country",
    POP = "Pop"
}

export enum MakeVideoLayoutTypes {
    LAYOUT_1,
    LAYOUT_2,
    LAYOUT_3
}

export interface MakeVideoChoiceStore {
    music: string
    videos: Array<string>
    title: string
    background: number
}

export interface MakeVideoSpriteConfig {
    x: number
    y: number
    group?: Phaser.Group
    tweenX?: number
    nextButton?: ButtonContainer
    sprites?: Array<MakeVideoSprite>
    edit?: boolean
    editButton?: ButtonContainer
}

export interface MakeVideoScreenTextConfig {
    step: number
    edit: boolean
}

export interface MakeVideoSprite {
    active: boolean
    destroy: () => void
    visible?: boolean
}

export interface MakeVideoSpriteContainer {
    disableAll: () => void
    enableAll: () => void
}

